(function() {
    var horizontal;
    var minDesktopSize = 1008;
    var mediaQuery = window.matchMedia(`(min-width: ${minDesktopSize}px)`);

    function initializeHorizontalScroll() {
        if (mediaQuery.matches) {
            if (!horizontal) {
                horizontal = new HorizontalScroll({ container: document.querySelector('.HorizontalLanding') });
            }
        } else {
            if (horizontal) {
                horizontal.destroy();
                horizontal = null;
            }
        }
    }

    // Initialize on load
    initializeHorizontalScroll();

    // Add event listener for media query changes
    mediaQuery.addEventListener('change', initializeHorizontalScroll);    
})();
